import { $, CustomEventWithDetail, html, on, rune, View } from 'rune-ts';
import klass from './ButtonRadio.module.scss';
import { typoPcMo } from '../../../../shared/typography/typo';

export interface ButtonRadioProps {
  id?: string;
  name?: string;
  label?: string;
  value?: string;
  bold_label?: boolean;
  disabled?: boolean;
  active?: boolean;
  fit?: boolean;

  /**
   * @deprecated
   * Use `styles.wrapper`
   *
   * `styles.wrapper`보다 우선 순위를 가집니다.
   */
  wrapper_klass?: string;

  styles?: {
    wrapper?: string;
    label?: string;
  };
}

class InputRadio extends View<ButtonRadioProps> {
  override template() {
    const { active, name, disabled, value } = this.data;

    return html`
      <input
        class="${klass.radio}"
        ${disabled ? 'disabled' : ''}
        ${active ? 'checked' : ''}
        type="radio"
        name="${name}"
        value="${value ?? ''}"
      />
    `;
  }
}

export class ButtonRadioClickEvent extends CustomEventWithDetail<ButtonRadioProps> {}

export class ButtonRadio extends View<ButtonRadioProps> {
  inputRadio: InputRadio;

  static ClickEvent = ButtonRadioClickEvent;

  constructor(data: ButtonRadioProps) {
    if (data.wrapper_klass) {
      data.styles = {
        wrapper: data.wrapper_klass,
        label: data.styles?.label,
      };
    }
    super(data);
    this.inputRadio = new InputRadio(this.data);
  }

  override template() {
    const { label, bold_label, styles = {} } = this.data;
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    return html`
      <label data-fit="${!!this.data.fit}" class="${klass.button_radio} ${styles.wrapper}">
        <span class="${klass.radio_wrapper}">
          ${this.inputRadio}
          <span class="${klass.button}"></span>
          ${label
            ? html`<span
                class="${styles.label ??
                typoPcMo({
                  is_mobile,
                  pc: bold_label ? '16_bold' : '16_medium',
                  mo: bold_label ? '14_bold' : '14_medium',
                })}"
                >${label}</span
              >`
            : ''}
        </span>
      </label>
    `;
  }

  public isActive() {
    return (this.inputRadio.element() as HTMLInputElement).checked;
  }

  public setActive(active: boolean): this {
    this.data.active = active;
    return this.redraw();
  }

  static getCheckedValue(name: string, parent?: HTMLElement) {
    return $(parent ?? document)
      .find(`input[type="radio"][name="${name}"]:checked`)
      ?.getValue();
  }

  @on('click')
  onClick() {
    this.dispatchEvent(ButtonRadio.ClickEvent, { bubbles: true, detail: this.data });
  }
}
